module.exports = __webpack_public_path__ + "img/DW365-257.9e21c391.jpg";